import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_2 = { class: "lottie-container" }

import { computed } from 'vue'
  import loadingAnimation from '../assets/lottiefiles/loadingAnimation.json'
  import { useStore } from 'vuex'
  import { Vue3Lottie } from 'vue3-lottie'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'FullPageLoading',
  setup(__props, { expose: __expose }) {

  const store = useStore()

  const fullPageLoadingCount = computed(() => store.getters['fnol/getFullPageLoadingCount'])

  __expose({ fullPageLoadingCount })
  
return (_ctx: any,_cache: any) => {
  const _component_main_template = _resolveComponent("main-template")!

  return (_openBlock(), _createBlock(_component_main_template, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (fullPageLoadingCount.value > 0 )
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(Vue3Lottie), {
                  animationData: _unref(loadingAnimation),
                  height: 200,
                  width: 200,
                  loop: true,
                  speed: 2,
                  autoPlay: true
                }, null, 8, ["animationData"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})